import createReactClass from "create-react-class";

export default function() {
    const html = createReactClass({
        render() {
            return null;
        },
        componentWillReceiveProps(props) {
            setValue(this.props.field, props.globalState);
        },
        componentWillMount() {
            setValue(this.props.field, this.props.globalState);
        }
    });

    return {
        html: html,
        config: {
            invisible: true,
        },
    };
};

function setValue({config, state}, globalState) {
    var {refs} = config;

    var sum = (refs || []).reduce((sum, ref) => {
        const value = Number((globalState.fullState[ref] || {}).value);
        if (value === value) return sum + value;
        else return sum;
    }, 0);

    state.value = sum;
}


